<!-- <div class="order-reports-container col-md-12 no-padding">
    <div id="ordersreport">
        
<div class="col-xs-12 no-padding mt-10 mb-10">
    <div class="table-responsive">
        <table class="table-sm table-hover table-bordered" width="100%">
            <thead>
                <tr >
                    <th class="cursor-pointer">{{'orders-dashboard.RowLabels' |translate |translateKey}}</th>
                    <th class="cursor-pointer">{{'orders-dashboard.Completed' |translate |translateKey}}</th>
                    <th class="cursor-pointer">{{'orders-dashboard.Processing' |translate |translateKey}}</th>
                    <th class="cursor-pointer">{{'orders-dashboard.Shipped' |translate |translateKey}}</th>
                    <th class="cursor-pointer">{{'orders-dashboard.Pending' |translate |translateKey}}</th>
                    <th class="cursor-pointer">{{'orders-dashboard.Cancelled' |translate |translateKey}}</th>
                    <th class="cursor-pointer">{{'orders-dashboard.Accepted' |translate |translateKey}}</th>
                   
                    <th class="cursor-pointer">{{'orders-dashboard.Failed' |translate |translateKey}}</th>
                    <th class="cursor-pointer">{{'orders-dashboard.Review Window' |translate |translateKey}}</th>
                    <th class="cursor-pointer">{{'orders-dashboard.In Complete' |translate |translateKey}}</th>
                    <th class="cursor-pointer">{{'orders-dashboard.GrandTotal' |translate |translateKey}}</th>
                   
                </tr>
            </thead>
           
            <tbody  *ngIf="!isLoading && displayDashboard.length">
               <tr  *ngFor="let orderReport of displayDashboard">
                <td>{{orderReport.messageType  }}</td>
                <td>{{orderReport.completed ? orderReport.completed : 0}}</td>
                <td>{{orderReport.processing ? orderReport.processing : 0}}</td>
                <td>{{orderReport.shipped ? orderReport.shipped : 0  }}</td>
                <td>{{orderReport.pending ? orderReport.pending : 0  }}</td>
                <td>{{orderReport.cancelled ? orderReport.cancelled : 0  }}</td>
                <td>{{orderReport.accepted ? orderReport.accepted : 0  }}</td>
                <td>{{orderReport.failed ? orderReport.failed : 0  }}</td>
                <td>{{orderReport.review_window ? orderReport.review_window : 0  }}</td>
                <td>{{orderReport.inComplete ? orderReport.inComplete : 0  }}</td>
                <td>{{orderReport.count ? orderReport.count : 0}}</td>
               </tr>
            </tbody>
            
           
        </table>
    </div>
</div>
<div class="row no-margin">
    <div class="col-md-12 no-padding">
        <div id="icons-container" class="row float-right paddingtop-10">
            <div class="col-md-12 no-padding">
                
                <div class="col-md-3 right-padding-0 align-print-icon">
                    <button type="button" tabindex="0" (keyup.enter)="exportFile('print')" (click)="exportFile('print')"
                        class="iconButtons no-margin" [disabled]="isAllOrdersReportLoading || isLoading">
                        <span class="btn-label">
                            <img class="excel-image"  [src]="printIconUrl"
                                title="{{'customer-service.Print' |translate |translateKey }}" />
                        </span>
                    </button>
                </div>        
                <div class="col-md-3 right-padding-0">
                    <button type="button" tabindex="0" (keyup.enter)="exportFile('csv')" (click)="exportFile('csv')"
                        class="iconButtons no-margin" [disabled]="isAllOrdersReportLoading || isLoading">
                        <span class="btn-label">
                            <img class="excel-image" [src]="excelIconUrl"
                                alt="{{'reports.Export CSV' |translate |translateKey}}"
                                title="{{'reports.Export CSV' |translate |translateKey}}"/>
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="col-xs-12 no-padding mt-10 mb-10  full-row">
    <div class="table-responsive">
        <table class="table-sm table-hover table-bordered" width="100%">
            <thead>
                <tr >
                    <th class="cursor-pointer">{{'raw-data.FBO_ID' |translate |translateKey}}</th>
                    <th class="cursor-pointer">{{'raw-data.Email_ID' |translate |translateKey}}</th>
                    <th class="cursor-pointer">{{'raw-data.Member_Type' |translate |translateKey}}</th>
                    <th class="cursor-pointer">{{'raw-data.WebOrd_ID' |translate |translateKey}}</th>
                    <th class="cursor-pointer">{{'raw-data.SysOrd_ID' |translate |translateKey}}</th>
                    <th class="cursor-pointer">{{'raw-data.Order_Created_Date' |translate |translateKey}}</th>
                    <th class="cursor-pointer">{{'raw-data.Fulfillment_ID' |translate |translateKey}}</th>
                    <th class="cursor-pointer">{{'raw-data.FD_Failure' |translate |translateKey}}</th>
                    <th class="cursor-pointer">{{'raw-data.Ord_Status' |translate |translateKey}}</th>
                    <th class="cursor-pointer">{{'raw-data.Payment_Type' |translate |translateKey}}</th>
                    <th class="cursor-pointer">{{'raw-data.Payment_Status' |translate |translateKey}}</th>
                    <th class="cursor-pointer">{{'raw-data.Ord_Type' |translate |translateKey}}</th>
                    <th class="cursor-pointer">{{'raw-data.Ord_Source' |translate |translateKey}}</th>
                    <th class="cursor-pointer">{{'raw-data.Ord_Total' |translate |translateKey}}</th>
                    <th class="cursor-pointer">{{'raw-data.CCTotal' |translate |translateKey}}</th>
                    <th class="cursor-pointer">{{'raw-data.Ord_SentTo_AS400' |translate |translateKey}}</th>
                    <th class="cursor-pointer">{{'raw-data.AS400_Failure' |translate |translateKey}}</th>
                    <th class="cursor-pointer">{{'raw-data.Ord_ACK_From_AS400' |translate |translateKey}}</th>
                    <th class="cursor-pointer">{{'raw-data.Ord_SentTo_FD' |translate |translateKey}}</th>
  
                    <th class="cursor-pointer">{{'raw-data.Ord_ACK_From_FD' |translate |translateKey}}</th>
                    <th class="cursor-pointer">{{'raw-data.SysOrd_ID_SentTo_AS400' |translate |translateKey}}</th>
                    <th class="cursor-pointer">{{'raw-data.SysOrd_ID_FailureReason' |translate |translateKey}}</th>
                    <th class="cursor-pointer">{{'raw-data.SysOrd_ReceivedFrom_AS400' |translate |translateKey}}</th>
                    <th class="cursor-pointer">{{'raw-data.Processing_Period' |translate |translateKey}}</th>
                    <th class="cursor-pointer">{{'raw-data.Fulfillment_ID_From_FD
  
                      ' |translate |translateKey}}</th>
                    <th class="cursor-pointer">{{'raw-data.Ord_ShipConf_From_FD' |translate |translateKey}}
                  </th>
                    <th class="cursor-pointer">{{'raw-data.ShipConf_SentTo_AS400' |translate |translateKey}}
                  </th>
                    <th class="cursor-pointer">{{'raw-data.ShipConf_ACK_From_AS400
                      ' |translate |translateKey}}
                  </th>
                    <th class="cursor-pointer">{{'raw-data.Ord_Conf_Email
                      ' |translate |translateKey}}
                  </th>
                    <th class="cursor-pointer">{{'raw-data.Ship_Conf_Email
                      ' |translate |translateKey}}
                  </th>
                  <th class="cursor-pointer">{{'raw-data.PaybyLink_Email
                      ' |translate |translateKey}}
                  </th>
                  <th class="cursor-pointer">{{'raw-data.Report_DateTime
                      ' |translate |translateKey}}
                  </th>
                  <th class="cursor-pointer">{{'raw-data.ERPNumber_Received'|translate |translateKey}}</th>
                  <th class="cursor-pointer">{{'raw-data.ERP_Failure' |translate |translateKey }}</th>
                  <th class="cursor-pointer">{{'raw-data.Order_Submitted_ToERP' |translate |translateKey }}</th>
                  <th class="cursor-pointer">{{'raw-data.Order_Shipped_From' |translate |translateKey }}</th>
                </tr>
            </thead>
            <tbody  *ngIf="!isLoading && dashboardReports && dashboardReports.length > 0">
               <tr *ngFor="let orderReport of dashboardReports | paginate: {  id: 'order-reports-pagination', itemsPerPage: pageSize, currentPage: pageNumber, totalItems: pageCount };let i=index;trackBy:trackByItem">
                <td>{{orderReport.fboId}}</td>
                <td>{{orderReport.emailId ? orderReport.emailId : ''}}</td>
                <td>{{orderReport.memberType ? orderReport.memberType : ''}}</td>
                <td><a (click)="onClickWebOrderNumber(orderReport.webOrdID)">{{orderReport.webOrdID ? orderReport.webOrdID : ''}}</a></td>
                <td>{{orderReport.sysOrdID ? orderReport.sysOrdID : ''}}</td>
                <td>{{orderReport.orderCreatedDate ? orderReport.orderCreatedDate : ''}}</td>
                <td>{{orderReport.fulfillmentID ? orderReport.fulfillmentID : ''}}</td>
                <td>{{orderReport.fDFailure ? orderReport.fDFailure : ''}}</td>
                <td>{{orderReport.ordStatus ? orderReport.ordStatus : ''}}</td>
                <td>{{orderReport.paymentType ? orderReport.paymentType : '' }}</td>
                <td><a (click)="onClickPaymentStatus(orderReport.webOrdID)">{{orderReport.paymentStatus ? orderReport.paymentStatus : ''}}</a></td>
                <td>{{orderReport.ordType ? orderReport.ordType : '' }}</td>
                <td>{{orderReport.ordSource ? orderReport.ordSource : '' }}</td>
                <td>{{orderReport.ordTotal ? orderReport.ordTotal : '' }}</td>
                <td>{{orderReport.totalCC ? orderReport.totalCC : '' }}</td>
                <td>{{orderReport.ordSentToAS400 ? orderReport.ordSentToAS400 : ''}}</td>
                <td>{{orderReport.aS400Failure ? orderReport.aS400Failure : ''}}</td>
                <td>{{orderReport.ordACKFromAS400 ? orderReport.ordACKFromAS400 : ''}}</td>
                <td>{{orderReport.ordSentToFD ? orderReport.ordSentToFD : ''}}</td>
                <td>{{orderReport.ordACKFromFD ? orderReport.ordACKFromFD : ''}}</td>
                <td>{{orderReport.sysOrdIDSentToAS400 ? orderReport.sysOrdIDSentToAS400 : ''}}</td>
                <td>{{orderReport.sysytemOrderNumberFailureReason ? orderReport.sysytemOrderNumberFailureReason : ''}}</td>
                <td>{{orderReport.sysOrdReceivedFromAS400 ? orderReport.sysOrdReceivedFromAS400 : ''}}</td>
                <td>{{orderReport.processingPeriod ? orderReport.processingPeriod : ''}}</td>
                <td>{{orderReport.fulfillmentIDFromFD ? orderReport.fulfillmentIDFromFD : ''}}</td>
                <td>{{orderReport.ordShipConfFromFD ? orderReport.ordShipConfFromFD : ''}}</td>
                <td>{{orderReport.shipConfSentToAS400 ? orderReport.shipConfSentToAS400 : ''}}</td>
                <td>{{orderReport.shipConfACKFromAS400 ? orderReport.shipConfACKFromAS400 : ''}}</td>
                <td>{{orderReport.orderConfirmationEmail ? orderReport.orderConfirmationEmail : '' }}</td>
                <td>{{orderReport.shipconfirmationEmail ? orderReport.shipconfirmationEmail : ''}}</td>
                <td>{{orderReport.payByLinKEmail ? orderReport.payByLinKEmail : ''}}</td>
                <td>{{orderReport.reportDateTime ? orderReport.reportDateTime : ''}}</td>
                <td>{{orderReport.eRPNumberReceived ? orderReport.eRPNumberReceived : ''}}</td>
                <td>{{orderReport.erpFailure ? orderReport.erpFailure : '' }}</td>
                <td>{{orderReport.orderSubmittedToERP ? orderReport.orderSubmittedToERP : '' }}</td>
                <td>{{orderReport.distributionCenter ? orderReport.distributionCenter : '' }}</td>
               </tr>
            </tbody>
            <tbody
            *ngIf="(!isLoading && (ordersCount && ordersCount.length === 0)) || (isResponseError && !isLoading)">
            <tr>
                <td colspan="29"  class="text-center ">{{'customer-service.No record(s) found' |translate | translateKey}}.</td>
            </tr>
        </tbody>
        <tbody *ngIf="isLoading">
            <tr>
                <td colspan="29" class="text-center">{{'customer-service.Loading Results, Please wait.'|translate | translateKey}}.</td>
            </tr>
        </tbody>
           
        </table>
    </div>
    <div class="mt-5 paddingbot-20"
                *ngIf="dashboardReports && dashboardReports.length > 0">
                <span>{{pageCount}} {{'customer-service.record(s) found' |translate |translateKey}}</span>
                <pagination-controls  [id]="paginationInstance.id" (pageChange)="pageChange($event)" class="pull-right">
                </pagination-controls>
    </div>
</div>

<div class="col-md-12 padding-lr-0 paddingbot-20 custom-styling-dashboard-pagesize">
    <div class="col-md-4 padding-lr-0">
        <select class="form-control per-page-width" id="currentPageSize" [(ngModel)]="pageSize"
        [disabled]="!(dashboardReports && dashboardReports.length > 0)"
            (change)="pageSizeChange($event.target.value)" name="currentPageSize" #currentPageSize="ngModel">
            <option *ngFor="let pageSize of pageSizes" [value]="pageSize">{{pageSize}}</option>
        </select>
    </div>
</div>
    </div>
    </div>
   <div *ngIf="orderLogResponse  && orderLogResponse.length>0">
        <app-log-data-report [orderLogResponse]="orderLogResponse" [isPaymentLog]="isPaymentLog"></app-log-data-report>
    </div>   -->

    <div class="row w-100 no-margin message paddingtop-20"
    *ngIf="(!isLoading && (dashboardReports && dashboardReports.length === 0)) || (isResponseError && !isLoading)">
    <div class="w-100 messageContent text-center">
        <strong class="">{{'customer-service.No record(s) found' |translate | translateKey}}.</strong>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/reports/order-dashboard.component.html